import { render, staticRenderFns } from "./AddIntegrationModal.vue?vue&type=template&id=b206c080"
import script from "./AddIntegrationModal.vue?vue&type=script&lang=js"
export * from "./AddIntegrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports